import type { AssetModelCreateDto, AssetModelDto, AssetModelUpdateDto, AssetModelWithNavigationPropertiesDto, GetAssetModelsInput } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { LookupDto, LookupRequestDto } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class AssetModelService {
  apiName = 'Inventory';

  create = (input: AssetModelCreateDto) =>
    this.restService.request<any, AssetModelDto>({
      method: 'POST',
      url: '/api/inventory/asset-models',
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/asset-models/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, AssetModelDto>({
      method: 'GET',
      url: `/api/inventory/asset-models/${id}`,
    },
    { apiName: this.apiName });

  getLegalDocumentLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/asset-models/legal-document-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getList = (input: GetAssetModelsInput) =>
    this.restService.request<any, PagedResultDto<AssetModelWithNavigationPropertiesDto>>({
      method: 'GET',
      url: '/api/inventory/asset-models',
      params: { filterText: input.filterText, name: input.name, description: input.description, code: input.code, image: input.image, rpaType: input.rpaType, legalDocumentId: input.legalDocumentId, maintenanceCategoryId: input.maintenanceCategoryId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getMaintenanceCategoryLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/asset-models/maintenance-category-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getWithNavigationProperties = (id: string) =>
    this.restService.request<any, AssetModelWithNavigationPropertiesDto>({
      method: 'GET',
      url: `/api/inventory/asset-models/with-navigation-properties/${id}`,
    },
    { apiName: this.apiName });

  update = (id: string, input: AssetModelUpdateDto) =>
    this.restService.request<any, AssetModelDto>({
      method: 'PUT',
      url: `/api/inventory/asset-models/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
